import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Breadcrumb, Tabs, Pagination, Select } from 'antd';
import { Col, Container, Row } from 'react-bootstrap';
import { Sticky, StickyContainer } from 'react-sticky';
import { errorSwal } from '../../../helper/swalHelpers';
import iconDescarga from '../../../img/floating/descargar.svg'
import Footer from '../../components/foter/footer';
import Navbar from '../../components/navbar/navbar';
import Slider from '../../components/slider/slider';
import Filtro from '../../components/mercadoPublico/filtro';
import Seccion from '../../components/mercadoPublico/seccion';
import EmptyData from '../../components/mercadoPublico/emptyData';
import CentrosMantencion from '../../components/centrosMantencion/centrosMantencion';
import useWindowDimensions from '../../../hooks/Front/windowDimentions/useDimentions';
import useCategorias, { useListaPDF, useVehiculos } from '../../../hooks/Front/mercadoPublico/useMercadoPublico';

import '../../../css/formulariosPredefined.css';
import '../../../css/textsPredefined.css';
import Seo from '../../components/seo/seo';
import { orderVehiculosMercado } from '../../../helper';

const { TabPane } = Tabs;

const MercadoPublico = () => {
    const { width } = useWindowDimensions();

    const [categoriaSeleccionada, setCategoria] = useState(0)
    const [categorias, error] = useCategorias();
    const [vehiculos, errorVehiculo, isLoading, setVehiculos] = useVehiculos(categoriaSeleccionada);
    const [listaPDF, errorListaPDF] = useListaPDF();
    
    if (error || errorVehiculo) errorSwal("Ocurrió un error", "Vuelve a intentarlo", "Refrescar pagina");

    const handleChangeCategoria = (key) => {
        setCategoria(key);
    }

    const changeOrdenarVehiculos = (value) => {
        let lista = orderVehiculosMercado(vehiculos, value);
        setVehiculos([])
        setTimeout(() => {
            setVehiculos(lista)
        }, 40);
    }

    const ordenarMob = { changeOrdenarVehiculos }

    let margen = width <= 767 ? "51px" : width <= 991 ? "110px" : "118px"

    const renderTabBar = (props, DefaultTabBar) => (
        <Sticky topOffset={-90}>
            {({ style, isSticky }) => (
                <DefaultTabBar {...props} style={{ ...style, zIndex: 1, background: 'white', height: "80px", top: isSticky ? margen : '0px' }} />
            )}
        </Sticky>
    );


    return (
        <>
            <Navbar />
            <Seo title="Mercado público -" />
            <CentrosMantencion seccion="MERC_PUBLICO" />
            <Container fluid className="mb-general">
                <Row>
                    <Col xs={12}>
                        <Slider seccion="MERC_PUBLICO" />
                    </Col>
                </Row>
                <Row className="bg-white border-breadcrumb">
                    <Col className="my-1 my-md-3 px-2 ">
                        <Breadcrumb separator=">" className="parrafo-hyundai f-responsive-10">
                            <Breadcrumb.Item><Link to="/">Home</Link></Breadcrumb.Item>
                            <Breadcrumb.Item>
                                Mercado público
                            </Breadcrumb.Item>

                        </Breadcrumb>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} className="px-0 bg-white">
                        <StickyContainer>
                            <Tabs className="tab-hyundai" centered onChange={handleChangeCategoria} activeKey={categoriaSeleccionada.toString()} renderTabBar={renderTabBar} >
                                <TabPane  tab={<h5 className="bold-title-hyundai px-md-5 mb-1 mb-md-3 font-title-mobile">Todos</h5>} key={0}>
                                    <Row>
                                        <Col xs={12} sm={12} md={5} lg={4} xl={3} className="bg-white pr-0 d-none d-md-block">
                                            <ProductosEncontrados lista={vehiculos} />
                                        </Col>
                                        <Col xs={12} sm={12} md={7} lg={8} xl={9} className="border-mercado-l bg-white">
                                            <Container fluid className="d-none d-md-block">
                                                <Row className="px-1">
                                                    <Col className="bg-white" xs={12}>
                                                        <Row>
                                                            <Col>
                                                                <p className="parrafo-hyundai mt-4 mb-2">Ordenar por:</p>
                                                                <Select placeholder="Seleccione" onChange={changeOrdenarVehiculos} className="select-mercado-ordenar hyundai-select mb-4">
                                                                    <Select.Option value="a-z">A - z</Select.Option>
                                                                    <Select.Option value="z-a">Z - a</Select.Option>
                                                                    <Select.Option value="mayor-menor">Mayor precio - Menor precio</Select.Option>
                                                                    <Select.Option value="menor-mayor">Menor precio - Mayor precio</Select.Option>
                                                                </Select>
                                                            </Col>
                                                            <Col className="text-right align-self-end ">
                                                                <Pagination defaultCurrent={1} total={10} className="paginador-hyundai" />
                                                            </Col>
                                                        </Row>
                                                    </Col>

                                                </Row>
                                            </Container>
                                        </Col>
                                    </Row>
                                    <Row >
                                        <Filtro categorias={categorias} categoriaSeleccionada={categoriaSeleccionada} setCategoria={setCategoria} ordenarTab={ordenarMob} />
                                        <Col xs={12} sm={12} md={7} lg={8} xl={9} className="pl-0 container-mercado">
                                            {vehiculos && vehiculos.length > 0 ?
                                                vehiculos.map((seccion, i) => <Seccion seccion={seccion} key={i} />)
                                                :
                                                <EmptyData />
                                            }
                                        </Col>
                                    </Row>

                                </TabPane>
                                {categorias && categorias.length > 0 &&
                                    categorias.map(categoria =>
                                        <TabPane tab={<h5 className="bold-title-hyundai px-md-5 mb-1 mb-md-3 font-title-mobile">{categoria.Nombre}</h5>} key={categoria.idCategoria}>
                                            <Row>
                                                <Col xs={12} sm={12} md={5} lg={4} xl={3} className="bg-white pr-0 d-none d-md-block">
                                                    <ProductosEncontrados lista={vehiculos} />
                                                </Col>
                                                <Col xs={12} sm={12} md={7} lg={8} xl={9} className="border-mercado-l bg-white">
                                                    <Container fluid className="d-none d-md-block">
                                                        <Row className="px-1">
                                                            <Col className="bg-white" xs={12}>
                                                                <Row>
                                                                    <Col>
                                                                        <p className="parrafo-hyundai mt-4 mb-2">Ordenar por:</p>
                                                                        <Select placeholder="Seleccione" onChange={changeOrdenarVehiculos} className="select-mercado-ordenar hyundai-select mb-4">
                                                                            <Select.Option value="a-z">A - z</Select.Option>
                                                                            <Select.Option value="z-a">Z - a</Select.Option>
                                                                            <Select.Option value="mayor-menor">Mayor precio - Menor precio</Select.Option>
                                                                            <Select.Option value="menor-mayor">Menor precio - Mayor precio</Select.Option>
                                                                        </Select>
                                                                    </Col>
                                                                    <Col className="text-right align-self-end ">
                                                                        <Pagination defaultCurrent={1} total={10} className="paginador-hyundai" />
                                                                    </Col>
                                                                </Row>
                                                            </Col>

                                                        </Row>
                                                    </Container>
                                                </Col>
                                            </Row>
                                            <Row >
                                                <Filtro categorias={categorias} categoriaSeleccionada={categoriaSeleccionada} setCategoria={setCategoria} ordenarTab={ordenarMob} />
                                                <Col className="container-mercado pl-0" xs={12} sm={12} md={7} lg={8} xl={9}>
                                                    {vehiculos && vehiculos.length > 0 ?
                                                        vehiculos.map((seccion, i) => seccion.idCategoria.toString() === categoriaSeleccionada && <Seccion seccion={seccion} key={i} />) :
                                                        <EmptyData />
                                                    }
                                                </Col>
                                            </Row>
                                        </TabPane>
                                    )
                                }
                            </Tabs>
                        </StickyContainer>
                    </Col>
                </Row>
            </Container>
            {listaPDF && listaPDF.length > 0 &&
                <BottomBar listaPDF={listaPDF} />
            }
            <Footer float={true} />
        </>
    )
};

const BottomBar = ({ listaPDF }) => {
    if(!listaPDF && listaPDF.length <=0 && !listaPDF[0].Valor) return null;
    return (
        <Container className="bg-white fixed-bottom floating-shadow" fluid>
            <Row>
                <Col className="px-0 min-h-floating bg-cotizar-floating">
                    <a href={listaPDF[0].Valor} target="_blank" rel="noopener noreferrer">
                        <Button type="text" className="w-100 h-100 bold-title-hyundai px-0">
                            {/* <img src={iconDescarga} className="img-fluid mr-3" alt="descargar-ficha" />Lista de productos y precios */}
                            <img src={iconDescarga} alt="Descargar Lista de productos" className="img-fluid icon-floating mr-md-2 mr-lg-3" />
                            <h6 className="bold-title-hyundai d-none d-md-inline text-white">Descarga lista de productos</h6>
                            <p className="bold-title-hyundai mb-0 mt-1 font-floating-btn d-md-none color-btn-floating text-white">Descarga lista de productos</p>
                        </Button>
                    </a>
                </Col>
            </Row>
        </Container>
    )
}

const ProductosEncontrados = ({ lista }) => {

    const [productosEncontrados, setProductos] = useState(undefined)

    useEffect(() => {
        if (lista) {
            const sumarTodo = (array) => {
                let i = 0;
                array.map(item => i += item.vehiculos.length);
                setProductos(i);

            }
            sumarTodo(lista);
        }

    }, [lista]);
    let sinProductos = !productosEncontrados ? true : productosEncontrados < 1 ? true : false
    return (
        <Container className="border-productosc " fluid>
            <Row>
                <Col className="mb-4 mt-5" xs={12}>
                    <h5 className="bold-title-hyundai">Vehículos</h5>
                    {productosEncontrados !== undefined &&
                        <>
                            {sinProductos === true ?
                                <p className="parrafo-hyundai">No se encontraron productos.</p>
                                :
                                <p className="parrafo-hyundai">{productosEncontrados} productos encontrados</p>
                            }
                        </>
                    }


                </Col>
            </Row>
        </Container>
    )
};
export default MercadoPublico;
